import HelmetHelper from 'components/Helmet/HelmetHelper';
import Container from '../../components/Layout/Container';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import SendIcon from '@mui/icons-material/ArrowForward';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const NotFound = () => {
  return (
    <>
      <HelmetHelper title="404 - Not found." />
      <Container
        maxWidth="sm"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 95px)',
          minHeight: '500px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            flexDirection: 'column',
            flexGrow: 1,
          }}
        >
          <Typography variant="h2" gutterBottom component="h2" align="center">
            Looks like the page you’re looking for doesn’t exist, is temporarily unavailable or has been removed.
          </Typography>
          <Box marginY={[3, 5]}>
            <Button component={RouterLink} to={'/'} size="large" color="secondary" variant="outlined" endIcon={<SendIcon />}>
              Take Me Home
            </Button>
          </Box>
        </Box>
        <Box mb={['30px', '60px']}>
          <Typography align="center" variant="subtitle1" gutterBottom component="div">
            If you think we’ve misplaced your page,{` `}
            <Link fontSize="inherit" underline="always" to="/page/contact-us" component={RouterLink}>
              contact
            </Link>
            {` `}us and let us know.
          </Typography>
        </Box>
      </Container>
    </>
  );
};

export default NotFound;
